import React from 'react';
import { Typography, LinearProgress } from '@material-ui/core';
import { Icon } from '@saviynt/design-system';
import PropTypes from 'prop-types';
import useStyles from './styles/ProgressIndicator.styles';

const ProgressIndicator = ({ 
  message, 
  showProgress = false,
  variant = 'info' 
}) => {
  const classes = useStyles();
  
  const getVariantConfig = () => {
    const variants = {
      info: {
        backgroundColor: 'rgba(55, 81, 255, 0.08)',
        borderColor: 'rgba(55, 81, 255, 0.2)',
        textColor: 'rgba(55, 81, 255, 1)',
        icon: 'InfoCircleFilledSeparateColors',
        iconColor: '--color-foreground-info-medium',
        progressColor: 'rgba(55, 81, 255, 1)'
      },
      success: {
        backgroundColor: 'rgba(46, 125, 50, 0.08)',
        borderColor: 'rgba(46, 125, 50, 0.2)',
        textColor: '#2e7d32',
        icon: 'CheckCircleFilledSeparateColors',
        iconColor: '--color-foreground-success-medium',
        progressColor: '#2e7d32'
      },
      warning: {
        backgroundColor: 'rgba(225, 151, 1, 0.08)',
        borderColor: 'rgba(225, 151, 1, 0.2)',
        textColor: '#e19701',
        icon: 'AlertWarningFilledSeparateColors',
        iconColor: '--color-foreground-warning-medium',
        progressColor: '#e19701'
      },
      error: {
        backgroundColor: 'rgba(211, 47, 47, 0.08)',
        borderColor: 'rgba(211, 47, 47, 0.2)',
        textColor: '#d32f2f',
        icon: 'AlertCriticalFilledSeparateColors',
        iconColor: '--color-foreground-critical-medium',
        progressColor: '#d32f2f'
      }
    };
    return variants[variant] || variants.info;
  };

  const config = getVariantConfig();

  return (
    <div 
      className={classes.container}
      style={{
        background: `linear-gradient(135deg, ${config.backgroundColor} 0%, ${config.backgroundColor.replace('0.08', '0.12')} 100%)`,
        borderLeft: `3px solid ${config.borderColor.replace('0.2', '1')}`
      }}
    >
      <div className={classes.content}>
        <Icon 
          kind={config.icon} 
          label={variant} 
          color={config.iconColor} 
          size='small' 
        />
        <Typography 
          variant="body2" 
          className={classes.message}
          style={{ color: config.textColor }}
        >
          {message}
        </Typography>
      </div>
      {showProgress && (
        <LinearProgress 
          className={classes.progress}
          style={{ 
            backgroundColor: config.borderColor.replace('0.2', '0.2'),
            color: config.progressColor
          }}
        />
      )}
    </div>
  );
};

ProgressIndicator.propTypes = {
  message: PropTypes.string.isRequired,
  showProgress: PropTypes.bool,
  variant: PropTypes.oneOf(['info', 'success', 'warning', 'error'])
};

ProgressIndicator.defaultProps = {
  showProgress: false,
  variant: 'info'
};

export default ProgressIndicator;